import { Component } from '@angular/core';

@Component({
  templateUrl: './authentication.component.html',
})
export class AuthComponent {
  constructor() { }
}
